import React, { FunctionComponent } from 'react'

import { TabProps } from './Tab'

export interface TabPanelProps {
  value: string | number
  selectedValue: string | number
  children: React.FunctionComponentElement<TabProps>
}

export const TabPanel: FunctionComponent<TabPanelProps> = ({ children, value, selectedValue }) => (
  <div role='tabpanel' hidden={selectedValue !== value} id={`tabpanel-${value}`} aria-labelledby={`tabpanel-${value}`}>
    {value === selectedValue && <>{children}</>}
  </div>
)
